import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { heroText } from "@/lib/pageHero";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Reveal } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { PageContentBlocks } from "@/components/site/PageContentBlocks";
import { useServiceCards, ServiceCard } from "@/components/site/CommunityServices";
import { ShareButton } from "@/components/site/ShareButton";
import { useLang } from "@/context/LanguageContext";
import { EditableText } from "@/components/site/edit/EditableText";
import { SectionShell } from "@/components/site/edit/SectionShell";

export default function ServicesPage() {
  const { t, lang } = useLang();
  const cards = useServiceCards();
  const { data: settings = {} } = useQuery({ queryKey: ["settings"], queryFn: async () => (await api.get("/settings")).data });
  const headerImg = settings?.page_headers?.services;
  const ht = heroText(settings, "services", lang, t, "services");

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="relative bg-[#F9F8F6] min-h-screen overflow-x-hidden" data-testid="services-page">
      <div className="grain" />
      <Navbar />

      <PageHero image={headerImg} eyebrow={ht("eyebrow")} title={ht("title")} description={ht("desc")} testid="services-hero"
        action={<ShareButton path="services" title={ht("title")} light testid="services-share-btn" />} />

      <PageContentBlocks page="services" position="top" />

      <SectionShell id="services-sec-1" label="Section 1" noReorder>
      <section className="pt-14 sm:pt-16 pb-24 sm:pb-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          {cards.length === 0 ? (
            <p className="text-[#475569] py-16 text-center" data-testid="services-empty"><EditableText k="services.empty" as="span" /></p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="services-grid">
              {cards.map((card, i) => (
                <Reveal key={card.key} delay={(i % 3) * 0.08}>
                  <ServiceCard card={card} />
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
      </SectionShell>

      <PageContentBlocks page="services" position="bottom" />

      <Footer />
    </div>
  );
}
